import React from 'react';
import './Preview.css';
import ToggleBackToCreator from './ToggleBackToCreator/ToggleBackToCreator';
import ToggleBackText from './ToggleBackToCreator/ToggleBackText';
import VersionDropContainer from '../../containers/VersionDropContainer/VersionDropContainer';
import LinksAndCurrentLocation from '../../components/LinksAndCurrentLocation/LinksAndCurrentLocation';
import Switch from 'react-switch';
import { getTranslation } from '../../assets/creator/translations';

//mobile desktop toggle is disabled until mobile previews are added
//import MobileDesktopToggle from './MobileDesktopToggle/MobileDesktopToggle';

const InfoIcon = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path fill="#F5A623" fillRule="evenodd" d="M12 1.518c5.78 0 10.482 4.702 10.482 10.482 0 5.78-4.703 10.482-10.482 10.482C6.22 22.482 1.518 17.78 1.518 12 1.518 6.22 6.221 1.518 12 1.518zm0 1.5c-4.952 0-8.982 4.029-8.982 8.982 0 4.953 4.03 8.982 8.982 8.982 4.953 0 8.982-4.029 8.982-8.982 0-4.953-4.03-8.982-8.982-8.982zm0 8.223c.518 0 .937.42.937.937v4.83a.936.936 0 1 1-1.874 0v-4.83c0-.517.418-.937.936-.937zm0-4.249c.646 0 1.175.527 1.175 1.175s-.529 1.175-1.176 1.175a1.176 1.176 0 0 1 0-2.35z" />
    </svg>
)

const Preview = ({ isDragStarted, isPreviewOn, handleTogglePreview, showFixedElements, toggleShowFixedElements, showSwitchButton }) => {
    return (

    <div className="preview">

        <div className="toggle-creator">
            <ToggleBackToCreator isPreviewOn={isPreviewOn} onClick={handleTogglePreview} /> 
        </div>

        <div className="preview__group">
                <VersionDropContainer/>
            </div>

            <div className="preview__group">
                <InfoIcon/>
                <span className="preview__infotext">{getTranslation("BackCreatorTextFront")}</span>
                <ToggleBackText isPreviewOn={isPreviewOn} onClick={handleTogglePreview}/>
            </div>

            <React.Fragment>
                <div className='preview__option'>
                    <LinksAndCurrentLocation isDragStarted={isDragStarted} />
                </div>
            </React.Fragment>

            {showSwitchButton && (
                <label className="switch-container">
                    <input type="hidden" id="switchContainerInput"/>
                    <span>{getTranslation("Sw_ShowPopup")}</span>
                    <Switch height={20} width={48} onChange={toggleShowFixedElements} checked={showFixedElements} onColor={'#4a5de2'}/> 
                </label>
            )}
            {!showSwitchButton && (
                <label className="switch-container">
                    <input type="hidden" id="switchContainerInput"/>
                </label>
            )}
    </div>
    );
};

export default Preview;

